export interface RecorderDownloadInfo {
  version: string
  tag: string
  downloadUrl: string
  releaseUrl: string
}

const RECORDER_DOWNLOAD_INFO: RecorderDownloadInfo = {
  version: '0.1.11',
  tag: 'recorder-v0.1.11',
  downloadUrl:
    'https://github.com/enterfans001-eng/logmane/releases/download/recorder-v0.1.11/LogManeRecorder-0.1.11.dmg',
  releaseUrl: 'https://github.com/enterfans001-eng/logmane/releases/tag/recorder-v0.1.11'
}

export function getRecorderDownloadInfo(): RecorderDownloadInfo {
  return RECORDER_DOWNLOAD_INFO
}

export function isAudioUploadEnabled(
  env: Partial<Record<'VITE_ENABLE_AUDIO_UPLOAD', string | undefined>>
): boolean {
  return env.VITE_ENABLE_AUDIO_UPLOAD === 'true'
}
